import scheduledTripsImage from '../img/dashboard-background34.svg';
import activeRidesImage from '../img/dashboard-background2.svg';
import previousTripsImage from '../img/dashboard-background1.svg';

angular.module('relayHealth').controller('clientAdminDashboardCtrl', [
  '$scope',
  '$http',
  'API_BASE_URL',
  'Pubnub',
  '$rootScope',
  'pubnubNotificationFactory',
  '$timeout',
  'toaster',
  'checkAndClearETA',
  'loadingScreenFactory',
  'showBillingTOS',
  '$state',
  function clientAdminDashboardCtrl(
    $scope,
    $http,
    API_BASE_URL,
    Pubnub,
    $rootScope,
    pubnubNotificationFactory,
    $timeout,
    toaster,
    checkAndClearETA,
    loadingScreenFactory,
    showBillingTOS,
    $state,
  ) {
    // All forms must go inside it
    this.scheduledTripsImage = scheduledTripsImage;
    this.activeRidesImage = activeRidesImage;
    this.previousTripsImage = previousTripsImage;
    $scope.columnKey = null;
    $scope.tableColumns = [
      {
        displayText: 'No.',
        columnKey: 'no',
        show: true,
      },
      {
        displayText: 'Rider Name',
        columnKey: 'riderName',
        show: true,
      },
      {
        displayText: 'Organization',
        columnKey: 'organisation',
        isSortable: true,
        sortType: null,
        sortKey: 'org.name',
        show: $scope.showChildData(),
      },
      {
        displayText: 'Date & Time',
        columnKey: 'dateAndTime',
        isSortable: true,
        sortType: null,
        sortKey: 'trip_date_time',
        show: true,
      },
      {
        displayText: 'Status Bar',
        columnKey: 'statusBar',
        show: true,
      },
    ];
    $scope.forms = {
      filterRidesForm: {},
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };

    $scope.searchActiveRidesForm = {};
    /**
     * Initialize data that is required
     *
     */
    $scope.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if ($scope.userDetails) {
      showBillingTOS($scope.userDetails.first_time_visit, $scope, $state);
    }
    pubnubNotificationFactory.setUUID();
    pubnubNotificationFactory.subscribeUserIdChannel();
    let activeChanelGroup = '';
    const allListeners = {
      deregisterActiveChanel: null,
      deregister: null,
      deregisterUserIdListener: null,
      deregisterAppt: null,
    };

    let map; // maps
    let markers = [];
    let movingLatLng = null;

    let path = '';
    let scale = 1;
    let fillOpacity = '';
    let fillColor = '';
    let firstTimeLoad = true;
    let sortBy;
    const statusMapping = {
      'Finding Driver': {
        displayStatus: 'Finding Driver',
        clearRide: false,
      },
      'Driver Confirmed': {
        displayStatus: 'Driver Confirmed',
        clearRide: false,
      },
      'Driver Arrived': {
        displayStatus: 'Driver Arrived',
        clearRide: false,
      },
      'Patient Enroute': {
        displayStatus: 'Rider En Route',
        clearRide: false,
      },
      'Late Arrival': {
        displayStatus: 'Rider En Route Late Arrival',
        clearRide: false,
      },
      'Arrival Time Exceeded': {
        displayStatus: 'Late Arrival',
        clearRide: false,
      },
      'Variance Issue': {
        displayStatus: 'Ride Completed (Under Process)',
        clearRide: true,
      },
      'Variance Under': {
        displayStatus: 'Ride Completed (Under Process)',
        clearRide: true,
      },
      'Variance Over': {
        displayStatus: 'Ride Completed (Under Process)',
        clearRide: true,
      },
      'No Driver Available': {
        displayStatus: 'No Driver Available',
        clearRide: true,
      },
      'Potential Unavailability': {
        displayStatus: 'Potential Unavailability',
        clearRide: false,
      },
      'Ride Completed': {
        displayStatus: 'Ride Completed',
        clearRide: false,
      },
      'Pending Ride Request': {
        displayStatus: 'Pending Ride Request',
        clearRide: false,
      },
      'Failed CC Auth': {
        displayStatus: 'Failed CC Auth',
        clearRide: true,
      },
    };

    $scope.statusSelectOptions = [];
    Object.keys(statusMapping).forEach((key) => {
      if (key === 'Pending Ride Request') {
        $scope.statusSelectOptions.push({
          value: 'Pending Ride Request',
          displayText: 'Pending Ride Request',
        });
      } else if (key !== 'Variance Under' && key !== 'Variance Over') {
        $scope.statusSelectOptions.push({
          value: key,
          displayText: statusMapping[key].displayStatus,
        });
      }
    });

    $scope.dateRangeOptions = {
      opens: 'center',
      parentEl: '#current-app #page-wrapper',
      eventHandlers: {
        'apply.daterangepicker': function applyDaterangepicker(ev, picker) {
          $scope.searchActiveRidesForm.dateRange = {};
          if (picker) {
            if (
              typeof picker.startDate === 'object'
              && typeof picker.endDate === 'object'
            ) {
              $scope.searchActiveRidesForm.dateRange.startDate = `${picker.startDate.format(
                'YYYY-MM-DD',
              )} 00:00:00`;
              $scope.searchActiveRidesForm.dateRange.endDate = `${picker.endDate.format(
                'YYYY-MM-DD',
              )} 23:59:59`;
              return;
            }
          }

          const dateRangeFilter = document.getElementsByName('dateRange')[0]
            .value;

          if (dateRangeFilter) {
            const dateRangeFilterArr = dateRangeFilter.split(' - ');
            $scope.searchActiveRidesForm.dateRange.startDate = `${moment(
              new Date(dateRangeFilterArr[0]),
            ).format('YYYY-MM-DD')} 00:00:00`;
            $scope.searchActiveRidesForm.dateRange.endDate = `${moment(
              new Date(dateRangeFilterArr[1]),
            ).format('YYYY-MM-DD')} 23:59:59`;
          }
        },
      },
    };

    $scope.moment = moment;

    $scope.ridesStats = {
      // Stats to be shown in tiles at top of dashboard
      scheduledTrips: 0,
      activeRides: 0,
      completedTrips: 0,
    };

    $scope.allActiveRides = {
      data: [],
      selectedRide: 0,
      loading: true,
      rideDetailsLoading: true,
      mapping: {
        rideId: {
          // this object is written to just illustrate what is structure of each mapping
          indexInData: '0-9',
          rideDetails: {
            // fetched details for particular ride
          },
          lastUpdated: 'dateObject',
        },
      },
      pagination: {
        totalItems: 0,
        currentPage: 1,
        lastItem: 0,
        itemsPerPage: 10,
      },
    };

    $scope.filterFormOpen = false;

    let matchData;

    function resetVisibleOrgChoiceCount() {
      $scope.visibleOrgChoicesCount = 20;
    }
    $scope.loadMoreChoices = () => {
      $scope.visibleOrgChoicesCount += 20;
    };


    const getAllOrgsForSelectBox = async () => {
      loadingScreenFactory.showLoadingScreen();
      try {
        const { data: { organisations } } = await $http.get(`${API_BASE_URL}organisations`, {
          params: {
            marketSegment: true,
            fields: ['orgId', 'orgName'],
            displayOrgChildren: true,
          },
        });
        $scope.organizations = (organisations || []);
      } catch (error) {
        toaster.pop({
          type: 'error',
          title: error.data && error.data.message ? error.data.message : 'Could not fetch organizations.',
          showCloseButton: true,
          timeout: 10000,
        });
      } finally {
        loadingScreenFactory.hideLoadingScreen();
      }
    };

    function adjustPagination(listName) {
      $scope[listName].pagination.lastItem = ($scope[listName].pagination.currentPage - 1)
        * $scope[listName].pagination.itemsPerPage
        + 10;
      if (
        $scope[listName].pagination.lastItem
        > $scope[listName].pagination.totalItems
      ) {
        $scope[listName].pagination.lastItem = $scope[listName].pagination.totalItems;
      }
    }

    function setMapOnAll(mapObj) {
      for (let i = 0; i < markers.length; i += 1) {
        markers[i].setMap(mapObj);
      }
    }

    function deleteMarkers() {
      setMapOnAll(null);
      if (angular.isDefined($scope.movingMarker)) {
        $scope.movingMarker.setMap(null);
        $scope.movingMarker = undefined;
      }
      movingLatLng = undefined;
      markers = [];
    }


    function setMapPoints() {
      $timeout(() => {
        const mappedRide = $scope.allActiveRides.mapping[$scope.allActiveRides.selectedRide];

        const sourcelatLong = new google.maps.LatLng(
          mappedRide.rideDetails.source_lat_long[0],
          mappedRide.rideDetails.source_lat_long[1],
        );
        markers.push(
          new google.maps.Marker({
            position: sourcelatLong,
            map,
            label: 'S',
            icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
          }),
        );
        const destLatLong = new google.maps.LatLng(
          mappedRide.rideDetails.dest_lat_long[0],
          mappedRide.rideDetails.dest_lat_long[1],
        );
        markers.push(
          new google.maps.Marker({
            position: destLatLong,
            map,
            label: 'D',
            // icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
          }),
        );
        google.maps.event.trigger(map, 'resize');

        if (!movingLatLng) {
          map.setCenter(sourcelatLong);
        }
        map.setZoom(13);
      });
    }

    function updateDriverLocation(message) {
      if (angular.isDefined($scope.movingMarker)) {
        $scope.movingMarker.setMap(null);
        $scope.movingMarker = undefined;
      }

      // in case of completed ride_status,location is null
      if (!message.location_info) return;

      const validStatusesForETA = [
        'Driver Confirmed',
        'Driver Arrived',
        'Patient Enroute',
        'Late Arrival',
      ];

      if (
        validStatusesForETA.indexOf(
          $scope.allActiveRides.mapping[$scope.allActiveRides.selectedRide]
            .rideDetails.ride_status,
        ) < 0
      ) {
        return;
      }

      $scope.allActiveRides.mapping[
        $scope.allActiveRides.selectedRide
      ].rideDetails.driver_eta = message.location_info.eta;
      movingLatLng = new google.maps.LatLng(
        message.location_info.latitude,
        message.location_info.longitude,
      );

      const mapObj = {
        position: movingLatLng,
        map,
        icon: {
          path,
          scale,
          //  rotation: message.location_info.bearing,
          fillColor,
          fillOpacity,
          strokeWeight: 2,
          strokeOpacity: 0.5,
        },
        label: '',
      };

      if (firstTimeLoad && map) {
        map.setCenter(movingLatLng);
        firstTimeLoad = false;
      }

      if (message.location_info.bearing) {
        mapObj.icon.rotation = message.location_info.bearing;
      }
      $scope.allActiveRides.mapping[
        $scope.allActiveRides.selectedRide
      ].rideDetails.driver_eta = message.location_info.eta;
      $scope.movingMarker = new google.maps.Marker(mapObj);
      $scope.$apply();
    }

    function getRideDetailsById() {
      if (
        $scope.allActiveRides.selectedRide === 0
        && !$scope.allActiveRides.mapping[$scope.allActiveRides.selectedRide]
      ) return;
      deleteMarkers();
      const mappedRide = $scope.allActiveRides.mapping[$scope.allActiveRides.selectedRide];
      let loadAgain = false;

      // subscribing and unsbscribing appt_track channel on this function
      if (mappedRide.rideDetails.id) {
        if ($scope.lastSubscribedAppointment) {
          pubnubNotificationFactory.unsubscribeChannel(
            `appt_track${$scope.lastSubscribedAppointment}`,
          );
          pubnubNotificationFactory.unsubscribeChannel(
            `appt${$scope.lastSubscribedAppointment}`,
          );
        }
        firstTimeLoad = true;

        // $scope.rideDetails.provider_id = 2;
        if (mappedRide.rideDetails.provider_id === 1) {
          // in case of uber
          // eslint-disable-next-line max-len
          path = 'M343.8,271.88a34.45,34.45,0,0,0,1.55,9.84l2.49,5.33,59.59-13.17L407.9,463.8c0,3.71,0,7.44-.05,11.18q-0.09,11.21-.36,22.59c-0.28,11.1-.68,22.32-1.19,33.58L406.2,533c-1,22.72-2.47,45.67-4,68.53-2.13,30.93-4.49,61.67-6.43,91.5-1.43,22.11-2.62,43.73-3.32,64.49-0.48,14.26-.76,28.1-0.67,41.47,0,6.57.15,13,.36,19.36s0.59,12.75,1.09,19.26c0.25,3.25.51,6.51,0.83,9.8,0.94,9.84,2.19,19.85,3.63,29.82h0c1,6.65,2,13.27,3.16,19.88s2.32,13.2,3.58,19.69,2.6,12.89,3.94,19.17h0c0.67,3.14,1.33,6.19,2,9.27,2.06,9.22,4.17,18.16,6.27,26.63h0q2.1,8.48,4.15,16.31c2.73,10.45,5.36,20,7.72,28.2,3.54,12.36,6.51,21.89,8.29,27.54,1.19,3.76,1.87,5.8,1.87,5.8l6.13,21a12,12,0,0,0,2.18,4,17.14,17.14,0,0,0,1.14,1.28,30,30,0,0,0,6.37,4.8h0c1.3,0.76,2.72,1.56,4.25,2.28h0c1.53,0.73,3.17,1.45,4.92,2.14h0c14.11,5.58,35,10.07,60.06,13.6h0l1.19,0.14c5.52,0.77,11.27,1.51,17.15,2.19,0.4,0,.79.1,1.19,0.14,6.7,0.76,13.6,1.44,20.68,2.09h0c3.53,0.33,7.12.65,10.73,1h0c3.61,0.3,7.21.58,10.88,0.86h0c7.36,0.54,14.83,1,22.39,1.47h0c22.69,1.33,46.08,2.22,68.92,2.71h0c15.24,0.33,30.2.48,44.62,0.48h9.74c14.41,0,29.38-.15,44.61-0.48h0c22.84-.49,46.23-1.38,68.92-2.71h0c7.55-.44,15-0.93,22.39-1.47h0c3.67-.27,7.28-0.56,10.88-0.86h0c3.6-.3,7.2-0.63,10.73-1h0c7.07-.65,14-1.33,20.68-2.09,0.4,0,.79-0.1,1.19-0.14,5.88-.68,11.63-1.42,17.15-2.19l1.19-.14h0c25-3.53,46-8,60.06-13.6h0c1.75-.69,3.39-1.41,4.92-2.14h0c1.53-.73,3-1.52,4.25-2.28h0a30,30,0,0,0,6.37-4.8,17.13,17.13,0,0,0,1.14-1.28,12,12,0,0,0,2.18-4l6.27-20.86s0.68-2,1.87-5.8c1.78-5.65,4.75-15.17,8.29-27.54,2.36-8.24,5-17.76,7.72-28.2q2-7.83,4.15-16.31h0c2.1-8.47,4.21-17.41,6.27-26.63,0.69-3.08,1.35-6.13,2-9.27h0c1.34-6.27,2.68-12.69,3.94-19.17s2.45-13.08,3.58-19.69,2.2-13.22,3.16-19.88h0c1.44-10,2.68-20,3.63-29.82,0.31-3.29.58-6.54,0.83-9.8,0.5-6.51.88-12.94,1.09-19.26s0.32-12.79.36-19.36c0.08-13.37-.19-27.21-0.67-41.47-0.7-20.76-1.88-42.38-3.32-64.49-1.94-29.83-4.3-60.57-6.43-91.5-1.57-22.86-3-45.81-4-68.53l-0.1-1.81c-0.51-11.25-.91-22.48-1.19-33.58q-0.28-11.37-.36-22.59c0-3.74-.06-7.47,0-11.18L1046.28,274,1105.8,287l2.49-5.33a34.45,34.45,0,0,0,1.55-9.84,19.76,19.76,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.86,25.86,0,0,0-1.14-2.85,21.48,21.48,0,0,0-5.49-7.28h0a14,14,0,0,0-3.78-2.24l-51.92-18.5,0.41-167.31c0.62-1.14,1.24-2.25,1.81-3.38a135.75,135.75,0,0,0,6-13.46c0.85-2.23,1.62-4.44,2.33-6.66a144.59,144.59,0,0,0,5.39-23.35c0.66-4.48,1.15-9,1.5-13.6,0.18-2.29.3-4.62,0.41-6.94,0.23-4.65.35-9.34,0.41-14.17,0.12-9.66,0-19.75,0-30.44a384,384,0,0,0-2.59-45.32q-1-8.64-2.44-16.93a298,298,0,0,0-7.25-31.82c-0.73-2.54-1.49-5.08-2.28-7.56-2.37-7.46-5-14.63-7.93-21.59-1-2.32-1.92-4.63-3-6.9q-3.09-6.8-6.53-13.27c-1.14-2.16-2.32-4.32-3.52-6.42-2.4-4.21-4.94-8.32-7.57-12.32-1.31-2-2.68-4-4-5.9A227.4,227.4,0,0,0,995-240.53a234.92,234.92,0,0,0-20.68-19h0c-1.81-1.48-3.63-2.95-5.49-4.38h0c-1.86-1.43-3.74-2.85-5.65-4.23h0q-8.59-6.23-17.77-11.79h0c-2-1.23-4.09-2.48-6.17-3.66h0c-6.26-3.56-12.69-7-19.33-10.08h0c-2.2-1-4.44-2.05-6.68-3h0c-2.24-1-4.51-2-6.79-2.95h0c-4.58-1.9-9.21-3.71-13.94-5.42h0c-2.36-.85-4.75-1.67-7.15-2.47h0c-2.4-.81-4.82-1.62-7.25-2.38s-4.89-1.52-7.36-2.24h0c-2.47-.72-5-1.42-7.46-2.09h0q-3.75-1-7.57-1.95c-3.82-.95,0,0,0,0-7.64-1.88-15.43-3.6-23.37-5.09h0c-2.64-.49-5.31-0.93-8-1.38h0a514.11,514.11,0,0,0-58.4-6.33h0c-2.87-.15-5.76-0.27-8.65-0.38h0c-5.8-.22-11.62-0.38-17.51-0.43H714.68c-5.9.05-11.72,0.21-17.51,0.43h0c-2.89.11-5.79,0.23-8.65,0.38h0a514.11,514.11,0,0,0-58.4,6.33h0c-2.67.45-5.34,0.89-8,1.38h0c-7.94,1.48-15.73,3.2-23.37,5.09h0q-3.81.94-7.57,1.95c-3.76,1,0,0,0,0-2.5.67-5,1.38-7.46,2.09h0c-2.47.72-4.93,1.47-7.36,2.24s-4.86,1.57-7.25,2.38h0c-2.4.81-4.79,1.62-7.15,2.47h0c-4.73,1.71-9.36,3.52-13.94,5.42h0c-2.28.95-4.54,2-6.79,2.95h0c-2.24,1-4.48,2-6.68,3h0c-6.64,3.13-13.06,6.52-19.33,10.08h0c-2.08,1.18-4.13,2.43-6.17,3.66h0c-6.14,3.71-12,7.65-17.77,11.79h0c-1.9,1.38-3.79,2.81-5.65,4.23h0c-1.86,1.43-3.68,2.9-5.49,4.38h0a234.91,234.91,0,0,0-20.68,19,227.39,227.39,0,0,0-22.44,27.25c-1.37,1.95-2.73,3.9-4,5.9-2.62,4-5.16,8.11-7.57,12.32-1.2,2.1-2.38,4.26-3.52,6.42q-3.43,6.48-6.53,13.27c-1,2.27-2,4.58-3,6.9-2.91,7-5.56,14.14-7.93,21.59-0.79,2.49-1.55,5-2.28,7.56a298.05,298.05,0,0,0-7.25,31.82q-1.42,8.3-2.44,16.93a383.45,383.45,0,0,0-2.59,45.32c0,10.68-.12,20.78,0,30.44,0.06,4.83.18,9.52,0.41,14.17,0.12,2.33.24,4.65,0.41,6.94,0.35,4.58.84,9.12,1.5,13.6a144.6,144.6,0,0,0,5.39,23.35c0.71,2.22,1.48,4.43,2.33,6.66a135.74,135.74,0,0,0,6,13.46c0.58,1.13,1.19,2.24,1.81,3.38l0.41,167.31-51.92,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.48,21.48,0,0,0-5.49,7.28,25.87,25.87,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.77,19.77,0,0,0-.41,4.09h0ZM343.8,271.88a34.52,34.52,0,0,0,1.55,9.84l2.49,5.33,59.43-13.17,0.48,189.92C408,582.45,388.68,717.22,392,818.29s46.42,231.51,46.42,231.51l6.27,20.83c8.78,29.33,161.45,39.17,276.55,39.17h11.2c115.1,0,267.77-9.84,276.55-39.14l6.26-20.86s43.11-130.44,46.43-231.51-16-235.85-15.75-354.49l0.47-189.95,59.4,13.2,2.49-5.33a34.52,34.52,0,0,0,1.55-9.84,19.79,19.79,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.89,25.89,0,0,0-1.14-2.85,21.37,21.37,0,0,0-5.44-7.28h0a14,14,0,0,0-3.78-2.24l-51.82-18.5,0.41-167.31c19.8-36.37,17.77-69.26,17.77-112C1064.61-248,921-330.79,730.7-329.83h-7.78C532.58-330.83,389-248,389-45.25c0,42.74-2,75.63,17.77,112l0.41,167.31-51.82,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.37,21.37,0,0,0-5.44,7.28,25.9,25.9,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.8,19.8,0,0,0-.41,4.09h0ZM943.3,591.8a1212.83,1212.83,0,0,0,8.39,144.29c80.77-39,50.18-149.12,52.28-312.83,1-75.62,3.12-136.27,3.94-185C969.22,310,943.3,441.47,943.3,591.8ZM943.3,591.8c0,4.88,0,9.71.1,14.55,26.81-1.25,50.17-9.78,64.41-22.21q-0.2-10.66-.57-22c-13.58,13-36.86,22.21-63.94,23.92v5.74ZM897.31-304.13l1,7.75c4.17,32.79,43.08,57.36,90.42,59.78l11.81,0.57-8-8c-24.34-24.18-53.9-43.07-87.47-56.93ZM915.54,8.68s-37.47-121.26-53-160.37c-16.25-40.85-64.91-150.45-64.91-150.45s70.42,13.3,96,46.39c91,117.52,89.3,354.11,89.3,354.11M881.29-123l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L947.2-94.47c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM873.89-136l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18l-6.43-20.73c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM871.54-145.43l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L937.45-117c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM888.95-103.4l3.47,6a21.34,21.34,0,0,1,5.69-3.23c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L947.82-78c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM894.87-82.39l3.47,6A21.34,21.34,0,0,1,904-79.62c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L953.74-57c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM927.52,846c-3.35-12.62-2.45-23.57,9.6-30.13l29.68,3.79c10.24,10.46,8.21,20.93.26,31.39l-39.53-5h0ZM932.94,815.16c-2-12.4-1-23.08,9.13-28.68l28.24,3.61c4.93,9.87,8.64,19.76.25,29.88l-37.62-4.81h0ZM939.18,591.8a1216.6,1216.6,0,0,0,8.39,144.72l0.67,5.56,5.39-2.62c21-10.15,35-25.2,43.84-44.23s12.62-42,14-68.63c2.74-53.33-4.36-121.68-3.32-203.31,1-75.57,3.12-136.22,3.94-185l-7.88-1.71C964.95,309.41,939.18,441.07,939.18,591.8Zm8.29,0c0-138.75,22.35-261.38,55.91-334.95-1,45.58-2.66,99.24-3.52,166.36-1,82.08,6.06,150.63,3.37,203-1.34,26.2-5.15,48.34-13.37,66.06-7.38,15.91-18.5,28.13-34.67,37.29A1212.36,1212.36,0,0,1,947.47,591.8ZM532.32,804.58L553,922.9c7.22,41.32,80.87,74.49,173.85,77.61,93-3.12,166.63-36.29,173.85-77.61l20.68-118.32c0-20.23-17.75-36.52-39.8-36.52H572.11c-22,0-39.8,16.29-39.8,36.52h0ZM475.57,147.95a57,57,0,0,0,1.61,13.36h0l20.42,97.16c11,27,23.67,48.7,53.06,48.7H903.07c29.4,0,42.11-21.72,53.06-48.7l20.42-97.16h0a57,57,0,0,0,1.61-13.36c0-69.09-95.12-125.09-251.26-125.27-156.15.17-251.26,56.18-251.26,125.27h0ZM510.38,591.8A1212.82,1212.82,0,0,1,502,736.09C421.21,697,451.8,586.93,449.7,423.21c-1-75.62-3.12-136.27-3.94-185C484.45,310,510.38,441.47,510.38,591.8ZM510.38,591.8c0,4.88,0,9.71-.1,14.55-26.81-1.25-50.17-9.78-64.41-22.21q0.2-10.66.57-22c13.58,13,36.86,22.21,63.94,23.92v5.74ZM556.37-304.13l-1,7.75c-4.17,32.79-43.08,57.36-90.42,59.78l-11.81.57,8-8C485.48-268.21,515-287.1,548.61-301ZM538.13,8.68s37.47-121.26,53-160.37C607.38-192.54,656-302.14,656-302.14s-70.42,13.3-96,46.39c-91,117.52-89.3,354.11-89.3,354.11M572.39-123l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.74c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM579.8-136l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.73c14-26.34,38.27-41.81,56.38-35A24.31,24.31,0,0,1,579.8-136h0ZM582.13-145.43l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18L516.22-117c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM564.73-103.4l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L505.86-78c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM558.8-82.39l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L499.93-57c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM526.15,846c3.36-12.62,2.45-23.57-9.6-30.13l-29.68,3.79c-10.24,10.46-8.21,20.93-.26,31.39l39.53-5h0ZM520.74,815.16c2-12.4,1-23.08-9.13-28.68l-28.24,3.61c-4.93,9.87-8.64,19.76-.25,29.88l37.62-4.81h0ZM514.5,591.8a1216.61,1216.61,0,0,1-8.39,144.72l-0.67,5.56L500,739.46c-21-10.15-35-25.2-43.84-44.23s-12.62-42-14-68.63c-2.74-53.33,4.36-121.68,3.32-203.31-1-75.57-3.12-136.22-3.94-185l7.88-1.71C488.73,309.41,514.5,441.07,514.5,591.8Zm-8.29,0c0-138.75-22.35-261.38-55.91-334.95,1,45.58,2.66,99.24,3.52,166.36,1,82.08-6.06,150.63-3.37,203,1.34,26.2,5.15,48.34,13.37,66.06,7.38,15.91,18.5,28.13,34.67,37.29A1212.38,1212.38,0,0,0,506.21,591.8Z';
          scale = 0.02;
          fillOpacity = 0.5;
          fillColor = '#000';
          $scope.providerName = 'Uber';
        } else if (mappedRide.rideDetails.provider_id === 2) {
          // lyft
          // eslint-disable-next-line max-len
          path = 'M343.8,271.88a34.45,34.45,0,0,0,1.55,9.84l2.49,5.33,59.59-13.17L407.9,463.8c0,3.71,0,7.44-.05,11.18q-0.09,11.21-.36,22.59c-0.28,11.1-.68,22.32-1.19,33.58L406.2,533c-1,22.72-2.47,45.67-4,68.53-2.13,30.93-4.49,61.67-6.43,91.5-1.43,22.11-2.62,43.73-3.32,64.49-0.48,14.26-.76,28.1-0.67,41.47,0,6.57.15,13,.36,19.36s0.59,12.75,1.09,19.26c0.25,3.25.51,6.51,0.83,9.8,0.94,9.84,2.19,19.85,3.63,29.82h0c1,6.65,2,13.27,3.16,19.88s2.32,13.2,3.58,19.69,2.6,12.89,3.94,19.17h0c0.67,3.14,1.33,6.19,2,9.27,2.06,9.22,4.17,18.16,6.27,26.63h0q2.1,8.48,4.15,16.31c2.73,10.45,5.36,20,7.72,28.2,3.54,12.36,6.51,21.89,8.29,27.54,1.19,3.76,1.87,5.8,1.87,5.8l6.13,21a12,12,0,0,0,2.18,4,17.14,17.14,0,0,0,1.14,1.28,30,30,0,0,0,6.37,4.8h0c1.3,0.76,2.72,1.56,4.25,2.28h0c1.53,0.73,3.17,1.45,4.92,2.14h0c14.11,5.58,35,10.07,60.06,13.6h0l1.19,0.14c5.52,0.77,11.27,1.51,17.15,2.19,0.4,0,.79.1,1.19,0.14,6.7,0.76,13.6,1.44,20.68,2.09h0c3.53,0.33,7.12.65,10.73,1h0c3.61,0.3,7.21.58,10.88,0.86h0c7.36,0.54,14.83,1,22.39,1.47h0c22.69,1.33,46.08,2.22,68.92,2.71h0c15.24,0.33,30.2.48,44.62,0.48h9.74c14.41,0,29.38-.15,44.61-0.48h0c22.84-.49,46.23-1.38,68.92-2.71h0c7.55-.44,15-0.93,22.39-1.47h0c3.67-.27,7.28-0.56,10.88-0.86h0c3.6-.3,7.2-0.63,10.73-1h0c7.07-.65,14-1.33,20.68-2.09,0.4,0,.79-0.1,1.19-0.14,5.88-.68,11.63-1.42,17.15-2.19l1.19-.14h0c25-3.53,46-8,60.06-13.6h0c1.75-.69,3.39-1.41,4.92-2.14h0c1.53-.73,3-1.52,4.25-2.28h0a30,30,0,0,0,6.37-4.8,17.13,17.13,0,0,0,1.14-1.28,12,12,0,0,0,2.18-4l6.27-20.86s0.68-2,1.87-5.8c1.78-5.65,4.75-15.17,8.29-27.54,2.36-8.24,5-17.76,7.72-28.2q2-7.83,4.15-16.31h0c2.1-8.47,4.21-17.41,6.27-26.63,0.69-3.08,1.35-6.13,2-9.27h0c1.34-6.27,2.68-12.69,3.94-19.17s2.45-13.08,3.58-19.69,2.2-13.22,3.16-19.88h0c1.44-10,2.68-20,3.63-29.82,0.31-3.29.58-6.54,0.83-9.8,0.5-6.51.88-12.94,1.09-19.26s0.32-12.79.36-19.36c0.08-13.37-.19-27.21-0.67-41.47-0.7-20.76-1.88-42.38-3.32-64.49-1.94-29.83-4.3-60.57-6.43-91.5-1.57-22.86-3-45.81-4-68.53l-0.1-1.81c-0.51-11.25-.91-22.48-1.19-33.58q-0.28-11.37-.36-22.59c0-3.74-.06-7.47,0-11.18L1046.28,274,1105.8,287l2.49-5.33a34.45,34.45,0,0,0,1.55-9.84,19.76,19.76,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.86,25.86,0,0,0-1.14-2.85,21.48,21.48,0,0,0-5.49-7.28h0a14,14,0,0,0-3.78-2.24l-51.92-18.5,0.41-167.31c0.62-1.14,1.24-2.25,1.81-3.38a135.75,135.75,0,0,0,6-13.46c0.85-2.23,1.62-4.44,2.33-6.66a144.59,144.59,0,0,0,5.39-23.35c0.66-4.48,1.15-9,1.5-13.6,0.18-2.29.3-4.62,0.41-6.94,0.23-4.65.35-9.34,0.41-14.17,0.12-9.66,0-19.75,0-30.44a384,384,0,0,0-2.59-45.32q-1-8.64-2.44-16.93a298,298,0,0,0-7.25-31.82c-0.73-2.54-1.49-5.08-2.28-7.56-2.37-7.46-5-14.63-7.93-21.59-1-2.32-1.92-4.63-3-6.9q-3.09-6.8-6.53-13.27c-1.14-2.16-2.32-4.32-3.52-6.42-2.4-4.21-4.94-8.32-7.57-12.32-1.31-2-2.68-4-4-5.9A227.4,227.4,0,0,0,995-240.53a234.92,234.92,0,0,0-20.68-19h0c-1.81-1.48-3.63-2.95-5.49-4.38h0c-1.86-1.43-3.74-2.85-5.65-4.23h0q-8.59-6.23-17.77-11.79h0c-2-1.23-4.09-2.48-6.17-3.66h0c-6.26-3.56-12.69-7-19.33-10.08h0c-2.2-1-4.44-2.05-6.68-3h0c-2.24-1-4.51-2-6.79-2.95h0c-4.58-1.9-9.21-3.71-13.94-5.42h0c-2.36-.85-4.75-1.67-7.15-2.47h0c-2.4-.81-4.82-1.62-7.25-2.38s-4.89-1.52-7.36-2.24h0c-2.47-.72-5-1.42-7.46-2.09h0q-3.75-1-7.57-1.95c-3.82-.95,0,0,0,0-7.64-1.88-15.43-3.6-23.37-5.09h0c-2.64-.49-5.31-0.93-8-1.38h0a514.11,514.11,0,0,0-58.4-6.33h0c-2.87-.15-5.76-0.27-8.65-0.38h0c-5.8-.22-11.62-0.38-17.51-0.43H714.68c-5.9.05-11.72,0.21-17.51,0.43h0c-2.89.11-5.79,0.23-8.65,0.38h0a514.11,514.11,0,0,0-58.4,6.33h0c-2.67.45-5.34,0.89-8,1.38h0c-7.94,1.48-15.73,3.2-23.37,5.09h0q-3.81.94-7.57,1.95c-3.76,1,0,0,0,0-2.5.67-5,1.38-7.46,2.09h0c-2.47.72-4.93,1.47-7.36,2.24s-4.86,1.57-7.25,2.38h0c-2.4.81-4.79,1.62-7.15,2.47h0c-4.73,1.71-9.36,3.52-13.94,5.42h0c-2.28.95-4.54,2-6.79,2.95h0c-2.24,1-4.48,2-6.68,3h0c-6.64,3.13-13.06,6.52-19.33,10.08h0c-2.08,1.18-4.13,2.43-6.17,3.66h0c-6.14,3.71-12,7.65-17.77,11.79h0c-1.9,1.38-3.79,2.81-5.65,4.23h0c-1.86,1.43-3.68,2.9-5.49,4.38h0a234.91,234.91,0,0,0-20.68,19,227.39,227.39,0,0,0-22.44,27.25c-1.37,1.95-2.73,3.9-4,5.9-2.62,4-5.16,8.11-7.57,12.32-1.2,2.1-2.38,4.26-3.52,6.42q-3.43,6.48-6.53,13.27c-1,2.27-2,4.58-3,6.9-2.91,7-5.56,14.14-7.93,21.59-0.79,2.49-1.55,5-2.28,7.56a298.05,298.05,0,0,0-7.25,31.82q-1.42,8.3-2.44,16.93a383.45,383.45,0,0,0-2.59,45.32c0,10.68-.12,20.78,0,30.44,0.06,4.83.18,9.52,0.41,14.17,0.12,2.33.24,4.65,0.41,6.94,0.35,4.58.84,9.12,1.5,13.6a144.6,144.6,0,0,0,5.39,23.35c0.71,2.22,1.48,4.43,2.33,6.66a135.74,135.74,0,0,0,6,13.46c0.58,1.13,1.19,2.24,1.81,3.38l0.41,167.31-51.92,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.48,21.48,0,0,0-5.49,7.28,25.87,25.87,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.77,19.77,0,0,0-.41,4.09h0ZM343.8,271.88a34.52,34.52,0,0,0,1.55,9.84l2.49,5.33,59.43-13.17,0.48,189.92C408,582.45,388.68,717.22,392,818.29s46.42,231.51,46.42,231.51l6.27,20.83c8.78,29.33,161.45,39.17,276.55,39.17h11.2c115.1,0,267.77-9.84,276.55-39.14l6.26-20.86s43.11-130.44,46.43-231.51-16-235.85-15.75-354.49l0.47-189.95,59.4,13.2,2.49-5.33a34.52,34.52,0,0,0,1.55-9.84,19.79,19.79,0,0,0-.41-4.09c-0.1-.47-0.23-0.95-0.36-1.43s-0.26-1-.41-1.43a25.89,25.89,0,0,0-1.14-2.85,21.37,21.37,0,0,0-5.44-7.28h0a14,14,0,0,0-3.78-2.24l-51.82-18.5,0.41-167.31c19.8-36.37,17.77-69.26,17.77-112C1064.61-248,921-330.79,730.7-329.83h-7.78C532.58-330.83,389-248,389-45.25c0,42.74-2,75.63,17.77,112l0.41,167.31-51.82,18.5a14,14,0,0,0-3.78,2.24h-0.05a21.37,21.37,0,0,0-5.44,7.28,25.9,25.9,0,0,0-1.14,2.85c-0.15.46-.29,1-0.41,1.43s-0.27,1-.36,1.43a19.8,19.8,0,0,0-.41,4.09h0ZM943.3,591.8a1212.83,1212.83,0,0,0,8.39,144.29c80.77-39,50.18-149.12,52.28-312.83,1-75.62,3.12-136.27,3.94-185C969.22,310,943.3,441.47,943.3,591.8ZM943.3,591.8c0,4.88,0,9.71.1,14.55,26.81-1.25,50.17-9.78,64.41-22.21q-0.2-10.66-.57-22c-13.58,13-36.86,22.21-63.94,23.92v5.74ZM897.31-304.13l1,7.75c4.17,32.79,43.08,57.36,90.42,59.78l11.81,0.57-8-8c-24.34-24.18-53.9-43.07-87.47-56.93ZM915.54,8.68s-37.47-121.26-53-160.37c-16.25-40.85-64.91-150.45-64.91-150.45s70.42,13.3,96,46.39c91,117.52,89.3,354.11,89.3,354.11M881.29-123l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L947.2-94.47c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM873.89-136l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18l-6.43-20.73c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM871.54-145.43l3.89,6.75a23.89,23.89,0,0,1,6.37-3.61c19.43-7.3,48.48,16.34,59.33,40.9,0.35,0.79,1.39,2.76,2.75,5.18L937.45-117c-14-26.34-38.27-41.81-56.38-35a24.31,24.31,0,0,0-9.53,6.52h0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM864.46-171.2l3.06,9.42a32,32,0,0,1,9.07-3.09c26.59-4.75,56.85,31.9,63.84,65.49,1.08,5.17,14.22,44,14.6,48.94h6.84L941.73-113.5c-9.11-40-37.22-68.41-63.42-63.73a32.64,32.64,0,0,0-13.84,6h0v0ZM888.95-103.4l3.47,6a21.34,21.34,0,0,1,5.69-3.23c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L947.82-78c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM894.87-82.39l3.47,6A21.34,21.34,0,0,1,904-79.62c17.36-6.52,43.31,14.6,53,36.54,0.31,0.7,1.25,2.46,2.45,4.63L953.74-57c-12.53-23.53-34.19-37.35-50.36-31.27a21.72,21.72,0,0,0-8.52,5.82h0v0ZM927.52,846c-3.35-12.62-2.45-23.57,9.6-30.13l29.68,3.79c10.24,10.46,8.21,20.93.26,31.39l-39.53-5h0ZM932.94,815.16c-2-12.4-1-23.08,9.13-28.68l28.24,3.61c4.93,9.87,8.64,19.76.25,29.88l-37.62-4.81h0ZM939.18,591.8a1216.6,1216.6,0,0,0,8.39,144.72l0.67,5.56,5.39-2.62c21-10.15,35-25.2,43.84-44.23s12.62-42,14-68.63c2.74-53.33-4.36-121.68-3.32-203.31,1-75.57,3.12-136.22,3.94-185l-7.88-1.71C964.95,309.41,939.18,441.07,939.18,591.8Zm8.29,0c0-138.75,22.35-261.38,55.91-334.95-1,45.58-2.66,99.24-3.52,166.36-1,82.08,6.06,150.63,3.37,203-1.34,26.2-5.15,48.34-13.37,66.06-7.38,15.91-18.5,28.13-34.67,37.29A1212.36,1212.36,0,0,1,947.47,591.8ZM532.32,804.58L553,922.9c7.22,41.32,80.87,74.49,173.85,77.61,93-3.12,166.63-36.29,173.85-77.61l20.68-118.32c0-20.23-17.75-36.52-39.8-36.52H572.11c-22,0-39.8,16.29-39.8,36.52h0ZM475.57,147.95a57,57,0,0,0,1.61,13.36h0l20.42,97.16c11,27,23.67,48.7,53.06,48.7H903.07c29.4,0,42.11-21.72,53.06-48.7l20.42-97.16h0a57,57,0,0,0,1.61-13.36c0-69.09-95.12-125.09-251.26-125.27-156.15.17-251.26,56.18-251.26,125.27h0ZM510.38,591.8A1212.82,1212.82,0,0,1,502,736.09C421.21,697,451.8,586.93,449.7,423.21c-1-75.62-3.12-136.27-3.94-185C484.45,310,510.38,441.47,510.38,591.8ZM510.38,591.8c0,4.88,0,9.71-.1,14.55-26.81-1.25-50.17-9.78-64.41-22.21q0.2-10.66.57-22c13.58,13,36.86,22.21,63.94,23.92v5.74ZM556.37-304.13l-1,7.75c-4.17,32.79-43.08,57.36-90.42,59.78l-11.81.57,8-8C485.48-268.21,515-287.1,548.61-301ZM538.13,8.68s37.47-121.26,53-160.37C607.38-192.54,656-302.14,656-302.14s-70.42,13.3-96,46.39c-91,117.52-89.3,354.11-89.3,354.11M572.39-123l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.74c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM579.8-136l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18l6.43-20.73c14-26.34,38.27-41.81,56.38-35A24.31,24.31,0,0,1,579.8-136h0ZM582.13-145.43l-3.89,6.75a23.89,23.89,0,0,0-6.37-3.61c-19.43-7.3-48.48,16.34-59.33,40.9-0.35.79-1.39,2.76-2.75,5.18L516.22-117c14-26.34,38.27-41.81,56.38-35a24.31,24.31,0,0,1,9.53,6.52h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM589.22-171.2l-3.06,9.42a32,32,0,0,0-9.07-3.09c-26.59-4.75-56.85,31.9-63.84,65.49-1.08,5.17-14.22,44-14.6,48.94H491.8l20.14-63.06c9.11-40,37.22-68.41,63.42-63.73a32.64,32.64,0,0,1,13.84,6h0ZM564.73-103.4l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L505.86-78c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM558.8-82.39l-3.47,6a21.34,21.34,0,0,0-5.69-3.23c-17.36-6.52-43.31,14.6-53,36.54-0.31.7-1.25,2.46-2.45,4.63L499.93-57c12.53-23.53,34.19-37.35,50.36-31.27a21.72,21.72,0,0,1,8.52,5.82h0v0ZM526.15,846c3.36-12.62,2.45-23.57-9.6-30.13l-29.68,3.79c-10.24,10.46-8.21,20.93-.26,31.39l39.53-5h0ZM520.74,815.16c2-12.4,1-23.08-9.13-28.68l-28.24,3.61c-4.93,9.87-8.64,19.76-.25,29.88l37.62-4.81h0ZM514.5,591.8a1216.61,1216.61,0,0,1-8.39,144.72l-0.67,5.56L500,739.46c-21-10.15-35-25.2-43.84-44.23s-12.62-42-14-68.63c-2.74-53.33,4.36-121.68,3.32-203.31-1-75.57-3.12-136.22-3.94-185l7.88-1.71C488.73,309.41,514.5,441.07,514.5,591.8Zm-8.29,0c0-138.75-22.35-261.38-55.91-334.95,1,45.58,2.66,99.24,3.52,166.36,1,82.08-6.06,150.63-3.37,203,1.34,26.2,5.15,48.34,13.37,66.06,7.38,15.91,18.5,28.13,34.67,37.29A1212.38,1212.38,0,0,0,506.21,591.8Z';
          scale = 0.02;
          fillOpacity = 0.5;
          fillColor = '#000';
          $scope.providerName = 'Lyft';
        }

        // check eta's problem start
        checkAndClearETA(mappedRide.rideDetails);

        // check eta's problem end

        setMapPoints();

        // now compare if time here is not updated
        loadAgain = mappedRide.shouldLoad
          || new Date().getTime() - mappedRide.lastUpdated.getTime()
          >= 1 * 60 * 1000;

        if (!loadAgain) {
          $timeout(() => {
            $scope.lastSubscribedAppointment = mappedRide.rideDetails.appointment.id;
            pubnubNotificationFactory.subscribeChannel(
              `appt_track${mappedRide.rideDetails.appointment.id}`,
            );
            if (allListeners.deregister && typeof allListeners.deregister === 'function') {
              allListeners.deregister();
            }
            allListeners.deregister = $rootScope.$on(
              Pubnub.getMessageEventNameFor(
                `appt_track${mappedRide.rideDetails.appointment.id}`,
              ),
              (event, payload) => {
                const { message } = payload;
                if (
                  message.ride_id
                  && message.ride_id === $scope.allActiveRides.selectedRide
                ) {
                  updateDriverLocation(message);
                }
              },
            );
            pubnubNotificationFactory.subscribeChannel(
              `appt${mappedRide.rideDetails.appointment.id}`,
            );
            if (allListeners.deregisterAppt
              && typeof allListeners.deregisterAppt === 'function') {
              allListeners.deregisterAppt();
            }
            allListeners.deregisterAppt = $rootScope.$on(
              Pubnub.getMessageEventNameFor(
                `appt${mappedRide.rideDetails.appointment.id}`,
              ),
              // eslint-disable-next-line no-use-before-define
              notificationListener,
            );
          });
        }
      } else {
        loadAgain = true;
      }

      if (loadAgain) {
        $scope.allActiveRides.rideDetailsLoading = true;
        const getRideDetails = $http.get(
          `${API_BASE_URL}ride/getRideDetailsById/${
            $scope.allActiveRides.selectedRide
          }`,
          {
            params: {
              org_id: $scope.userDetails.organisation.id,
            },
          },
        );
        getRideDetails.then((result) => {
          if (result.data.success) {
            $scope.allActiveRides.mapping[
              $scope.allActiveRides.selectedRide
            ].rideDetails = result.data.rideDetails;
            $scope.allActiveRides.mapping[
              $scope.allActiveRides.selectedRide
            ].lastUpdated = new Date();
            $scope.allActiveRides.mapping[
              $scope.allActiveRides.selectedRide
            ].shouldLoad = false;
            if (
              result.data.rideDetails.ride_status === 'Ride Completed'
              && result.data.rideDetails.ride_category === 'completed'
            ) {
              $timeout(() => {
                // eslint-disable-next-line no-use-before-define
                filterActiveAppts();
              }, 1000 * 120);
            }
            getRideDetailsById();
          } else {
            toaster.pop({
              type: 'error',
              title: 'Not able to fetch Ride Details',
              showCloseButton: true,
              timeout: 10000,
            });
          }
          $scope.allActiveRides.rideDetailsLoading = false;
        });

        getRideDetails.catch((error) => {
          $scope.allActiveRides.rideDetailsLoading = false;
          toaster.pop({
            type: 'error',
            title:
              (error.data && error.data.message)
              || 'Not able to fetch updated Ride Details',
            showCloseButton: true,
            timeout: 10000,
          });
        });
      }
    }

    function notificationListener(event, payload) {
      let notDone = true;
      const { message } = payload;

      if (message.ride_data) {
        if ($scope.allActiveRides.mapping[message.ride_data.id]) {
          $scope.allActiveRides.mapping[message.ride_data.id].rideDetails = message.ride_data;
          $scope.allActiveRides.mapping[
            message.ride_data.id
          ].lastUpdated = new Date();
          getRideDetailsById();

          const indexNow = $scope.allActiveRides.mapping[message.ride_data.id].indexInData;
          if (
            $scope.allActiveRides.data[indexNow]
            && $scope.allActiveRides.data[indexNow].id === message.ride_data.id
          ) {
            notDone = false;
            if (
              message.ride_data.ride_status
              !== $scope.allActiveRides.data[indexNow].ride_status
            ) {
              // eslint-disable-next-line no-use-before-define
              filterActiveAppts();
            }
          }
        }
        if (notDone) {
          // eslint-disable-next-line no-use-before-define
          filterActiveAppts();
        }
      }
    }

    // listen to pubnub notifications:
    function listenForPubnubMessages() {
      if (!allListeners.deregisterUserIdListener) {
        allListeners.deregisterUserIdListener = $rootScope.$on(
          Pubnub.getMessageEventNameFor($scope.userDetails.user_id),
          notificationListener,
        );
      }

      if (activeChanelGroup) {
        if (allListeners.deregisterActiveChanel
          && typeof allListeners.deregisterActiveChanel === 'function') {
          allListeners.deregisterActiveChanel();
        }
        allListeners.deregisterActiveChanel = $rootScope.$on(
          Pubnub.getMessageEventNameFor(activeChanelGroup),
          notificationListener,
        );
      }
    }

    function getAllActiveRides(filters, sort = 'ride."updatedAt" DESC') {
      const params = Object.assign({}, filters);
      $scope.allActiveRides.loading = true;

      if (activeChanelGroup !== '') {
        pubnubNotificationFactory.unsubscribeChannelGroup(activeChanelGroup);
        activeChanelGroup = '';
      }

      params.org_id = $scope.userDetails.organisation.id;
      params.old_dashboard = false;
      const getAllActiveRidesCall = $http({
        url: `${API_BASE_URL}rides/getRidesListByRideCategory/active/${sort}/${($scope
          .allActiveRides.pagination.currentPage
          - 1)
          * $scope.allActiveRides.pagination.itemsPerPage}/${
          $scope.allActiveRides.pagination.itemsPerPage
        }`,
        method: 'GET',
        params,
      });

      getAllActiveRidesCall.then(
        (result) => {
          if (result.data.success) {
            $scope.allActiveRides.loading = false;
            let visibleSelectedRide = false;

            $scope.allActiveRides.data = result.data.data;
            $scope.allActiveRides.pagination.totalItems = result.data.totalCount;
            const someOldDate = new Date();
            someOldDate.setMinutes(someOldDate.getMinutes() - 5);

            $scope.allActiveRides.data.forEach((ride, index) => {
              if (
                !visibleSelectedRide
                && $scope.allActiveRides.selectedRide === ride.id
              ) {
                visibleSelectedRide = true;
              }
              if ($scope.allActiveRides.mapping[ride.id]) {
                $scope.allActiveRides.mapping[ride.id].indexInData = index;
                if ($scope.allActiveRides.mapping[ride.id].rideDetails.id) {
                  if (
                    $scope.allActiveRides.mapping[ride.id].rideDetails
                      .ride_status !== ride.ride_status
                  ) {
                    $scope.allActiveRides.mapping[ride.id].shouldLoad = true;
                  }
                }
              } else {
                $scope.allActiveRides.mapping[ride.id] = {
                  indexInData: index,
                  rideDetails: {},
                  loading: true,
                  lastUpdated: someOldDate,
                  shouldLoad: false,
                };
              }
            });
            adjustPagination('allActiveRides');

            if (!visibleSelectedRide) {
              if ($scope.allActiveRides.data.length > 0) {
                $scope.allActiveRides.selectedRide = $scope.allActiveRides.data[0].id;
              } else {
                $scope.allActiveRides.selectedRide = 0;
              }
            }

            activeChanelGroup = result.data.channelGroup;
            pubnubNotificationFactory.subscribeChannelGroup(activeChanelGroup);
            $timeout(() => {
              listenForPubnubMessages();
            });
          } else {
            $scope.allActiveRides.loading = false;
            $scope.allActiveRides.pagination.totalItems = 0;
            $scope.allActiveRides.data = [];
            $scope.allActiveRides.selectedRide = 0;
            adjustPagination('allActiveRides');
          }
          getRideDetailsById();
        },
      ).catch((error) => {
        toaster.pop({
          type: 'error',
          title: `Couldn't fetch rides: ${error.message || 'Internal Server Error'}`,
          showCloseButton: true,
          timeout: 3000,
        });
        $scope.allActiveRides.loading = false;
        $scope.allActiveRides.pagination.totalItems = 0;
        $scope.allActiveRides.data = [];
        $scope.allActiveRides.selectedRide = 0;
        adjustPagination('allActiveRides');
        getRideDetailsById();
      });
    }

    function filterActiveAppts() {
      matchData = {};
      if (Array.isArray($scope.searchActiveRidesForm.organizations) && $scope.searchActiveRidesForm.organizations.length) {
        const arrayItems = $scope.searchActiveRidesForm.organizations.map(itemValue => itemValue.id);
        matchData.organizations = `${arrayItems}`;
      }
      if (
        $scope.searchActiveRidesForm.patientName
        && $scope.searchActiveRidesForm.patientName.trim()
      ) {
        matchData.patientName = $scope.searchActiveRidesForm.patientName.trim();
      }
      if ($scope.searchActiveRidesForm.status) {
        matchData.status = $scope.searchActiveRidesForm.status;
      }
      if (
        $scope.forms.dateRange
        && $scope.forms.dateRange.startDate
        && $scope.forms.dateRange.endDate
      ) {
        matchData.dateRange = {};
        if (typeof $scope.forms.dateRange.startDate === 'object') {
          matchData.dateRange.startDate = `${$scope.forms.dateRange.startDate.format(
            'YYYY-MM-DD',
          )} 00:00:00`;
        }
        if (typeof $scope.forms.dateRange.endDate === 'object') {
          matchData.dateRange.endDate = `${$scope.forms.dateRange.endDate.format(
            'YYYY-MM-DD',
          )} 23:59:59`;
        }
      } else if (
        $scope.searchActiveRidesForm.dateRange
        && $scope.searchActiveRidesForm.dateRange.startDate
        && $scope.searchActiveRidesForm.dateRange.endDate
      ) {
        matchData.dateRange = {};
        matchData.dateRange.startDate = $scope.searchActiveRidesForm.dateRange.startDate;
        matchData.dateRange.endDate = $scope.searchActiveRidesForm.dateRange.endDate;
      }
      getAllActiveRides(matchData, sortBy);
    }

    $scope.filterRideFormSubmit = () => {
      filterActiveAppts();
    };

    $scope.refreshRidesTab = () => {
      $scope.allActiveRides.pagination.currentPage = 1;
      $scope.allActiveRides.pagination.totalItems = 0;
      $scope.allActiveRides.data = [];
      filterActiveAppts();
    };

    $scope.clearFilters = () => {
      $scope.forms.filterRidesForm = {};
      $scope.forms.dateRange = {};
      $scope.searchActiveRidesForm = {
        dateRange: {},
      };
      $scope.searchActiveRidesForm.organizations = {};
      $scope.refreshRidesTab();
    };

    $scope.rideListPageChange = function rideListPageChange() {
      filterActiveAppts();
    };

    $scope.getDisplayStatus = function getDisplayStatus(ride) {
      if (ride.ride_status === 'Ride Completed') {
        if (ride.ride_category === 'completed') {
          return 'Ride Completed';
        }
        if (ride.ride_category === 'active') {
          return 'Pending Ride Request';
        }
      }

      if (statusMapping[ride.ride_status]) {
        return statusMapping[ride.ride_status].displayStatus;
      }

      return ride.ride_status;
    };

    $scope.showClearRide = () => {
      const mappedRide = $scope.allActiveRides.mapping[$scope.allActiveRides.selectedRide];
      if (mappedRide && mappedRide.rideDetails.id) {
        if (statusMapping[mappedRide.rideDetails.ride_status]) {
          return statusMapping[mappedRide.rideDetails.ride_status].clearRide;
        }
      }
      return false;
    };

    $scope.selectRide = (ride) => {
      $scope.allActiveRides.selectedRide = ride.id;
      getRideDetailsById();
    };

    $scope.clearRideAction = (rideId) => {
      $scope.clearRideDisabled = true;
      const clearRideCall = $http({
        url: `${API_BASE_URL}ride/clear_from_view`,
        method: 'PUT',
        data: {
          ride_id: rideId,
        },
      });

      clearRideCall.then(
        (result) => {
          $scope.clearRideDisabled = false;
          if (result.data.success) {
            filterActiveAppts();
          } else {
            toaster.pop({
              type: 'error',
              title: 'Not able to clear this ride',
              showCloseButton: true,
              timeout: 10000,
            });
          }
        },
        (err) => {
          $scope.clearRideDisabled = false;
          toaster.pop({
            type: 'error',
            title: err.data.message,
            showCloseButton: true,
            timeout: 10000,
          });
        },
      );
    };

    function getRidesStats() {
      const endDateArr = moment().format('YYYY-MM-DD HH:mm:SS');
      const endDate = `${endDateArr.split(' ')[0]} 23:59:59`;
      const startDateToday = `${endDateArr.split(' ')[0]} 00:00:00`;
      const startDateTimeStamp = (moment(startDateToday).unix() - 86400 * 6) * 1000;
      const startDate = moment(startDateTimeStamp).format(
        'YYYY-MM-DD HH:mm:SS',
      );
      const getRidesStatsCall = $http.get(
        `${API_BASE_URL}SchdeduledRidesCount`,
        {
          params: {
            startDate,
            endDate,
            startDateToday,
            org_id: $scope.userDetails.organisation.id,
          },
        },
      );
      getRidesStatsCall.then((data) => {
        if (data.data.success) {
          $scope.ridesStats.scheduledTrips = data.data.data.scheduledApptCount;
          $scope.ridesStats.activeRides = data.data.data.activeRideCount;
          $scope.ridesStats.completedTrips = data.data.data.completedApptCount;
        } else {
          toaster.error('Error in getting Rides Stats');
        }
      });

      getRidesStatsCall.catch(() => {
        toaster.error('Error in getting Rides Stats');
      });
    }

    // temp code needs to relocate

    function listenCounts() {
      const orgId = $scope.userDetails.org_id;
      const userId = $scope.userDetails.role === 'mastersuperadmin'
        ? ''
        : $scope.userDetails.operations_team_id || '';
      const dateCurrent = moment
        .tz()
        .local()
        .format('YYYY_MM_DD');
      const channelName = `{CountChannelRedis}|${dateCurrent}-${orgId}-${userId}`;

      $rootScope.$on(
        Pubnub.getMessageEventNameFor(channelName),
        (event, payload) => {
          if (payload.message.scheduledApptCount[dateCurrent]) {
            $scope.ridesStats.scheduledTrips = payload.message.scheduledApptCount[dateCurrent];
          }
          if (payload.message.activeRideCount) {
            $scope.ridesStats.activeRides = payload.message.activeRideCount;
          }
          if (payload.message.completedApptCount) {
            $scope.ridesStats.completedTrips = payload.message.completedApptCount;
          }
        },
      );
    }

    /**
     * Init function to call all data initializing functions
     */
    function init() {
      getRidesStats();
      listenCounts();
      filterActiveAppts();
      listenForPubnubMessages();
      if ($scope.showChildData()) {
        resetVisibleOrgChoiceCount();
        getAllOrgsForSelectBox();
      }
    }

    $timeout(() => {
      map = new google.maps.Map(document.getElementById('rideDetailsMap'), {
        zoom: 12,
      });
      init();
    }, 1000);

    $scope.$on('$destroy', () => {
      Object.keys(allListeners).forEach((key) => {
        if (key && typeof key === 'function') { key(); }
      });
      pubnubNotificationFactory.unsubscribeUserIdChannel(
        $scope.userDetails.user_id,
      );
      $scope.filterFormOpen = false;
    });
    $scope.toggleSort = (column) => {
      if (!column.isSortable) {
        return;
      }
      Object.assign(column, {
        sortType: !column.sortType || column.sortType === 'DESC' ? 'ASC' : 'DESC',
      });
      $scope.columnKey = column.sortKey;
      sortBy = `${column.sortKey} ${column.sortType}`;
      getAllActiveRides(matchData, sortBy);
    };
  },
]);
